import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../grid';
import { PaymentMethods } from '../../payment-methods';
import ControlGroup from '../../control-group';
import IconFeature from '../../icon-feature';
import { TYPES } from '../../payment-methods/constants';

const defaultPaymentMethods = [TYPES.visa, TYPES.mastercard, TYPES.americanExpress, TYPES.paypal];

const FooterPaywall = ({
  paymentsTitle,
  moneyBackTitle = null,
  moneyBackDescription = null,
  securityTitle,
  securityDescription,
  paymentMethods = defaultPaymentMethods,
}) => (
  <Row className="ws-ui-paywall-footer">
    {Boolean(paymentMethods.length) && (
      <Col lg={4}>
        <ControlGroup title={paymentsTitle}>
          <PaymentMethods types={paymentMethods} />
        </ControlGroup>
      </Col>
    )}
    <Col lg={8}>
      <Row>
        {moneyBackTitle && (
          <Col className="gy-4 gy-lg-0" lg={6}>
            <IconFeature
              iconGlyph="payments"
              title={moneyBackTitle}
              description={moneyBackDescription}
            />
          </Col>
        )}
        <Col className="gy-4 gy-lg-0" lg={6}>
          <IconFeature
            iconGlyph="security"
            title={securityTitle}
            description={securityDescription}
          />
        </Col>
      </Row>
    </Col>
  </Row>
);

FooterPaywall.propTypes = {
  paymentsTitle: PropTypes.string.isRequired,
  moneyBackTitle: PropTypes.string,
  moneyBackDescription: PropTypes.string,
  securityTitle: PropTypes.string.isRequired,
  securityDescription: PropTypes.string.isRequired,
  paymentMethods: PropTypes.arrayOf(PropTypes.string),
};

export default FooterPaywall;
